import * as types from './actionTypes'
import { invitesPagination } from '../../utils/constants'

export const initialState = {
  invites: [],
  hasMore: true,
}

const Invites = (state = initialState, { type, payload }) => {
  switch (type) {
    case types.FETCH_INVITES:
      return {
        invites: [...state.invites, ...payload],
        hasMore: payload.length >= invitesPagination,
      }
    default:
      return state
  }
}

export default Invites
